export const rangeMapping = (
  value: number,
  fromMin: number,
  fromMax: number,
  toMin: number,
  toMax: number,
) => {
  return ((value - fromMin) * (toMax - toMin)) / (fromMax - fromMin) + toMin
}

/**
 * Get greatest common divisor of two given numbers
 * @param first
 * @param second
 * @returns
 */
function gcd(first: number, second: number): number {
  let a = first
  let b = second

  while (b) {
    ;[a, b] = [b, a % b]
  }
  return a
}

export function getRatioOfTwoNumbers(
  first: number,
  second: number,
  opts?: {
    replacements?: Record<string, string>
  },
) {
  const divisor = gcd(first, second)
  const originalRatio = `${first / divisor}:${second / divisor}`
  if (opts?.replacements && opts.replacements?.[originalRatio] != null) {
    return opts.replacements[originalRatio]
  }
  return originalRatio
}
